var scope_0 = require('/home/momar/development/porfolio/mySite/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/bb371b604cd58d6bdc41f05f30d23fb7.js').default;
var scope_1 = require('/home/momar/development/porfolio/mySite/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/f3bd3d479dc1221e7c918dfdf4331e15.js').default;export default
        Object.assign({}, scope_0,
scope_1 )
    